import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import Breadcrumbs from './shared/Breadcrumbs';

const PrivacyPolicy = () => {
  return (
    <div>
      <Header />
      <Content>
        <Breadcrumbs trail={[{name:'Home',url:'/'},{name:'Privacy Policy',url:'/privacy-policy'}]} />
        <h1>Privacy Policy</h1>
        <p>This Privacy Policy explains how Pabani Group Limited (referred to as "we," "us," or "our") collects, uses, and protects your personal information when you use our website (the "Site"). By using the Site, you agree to the terms of this Privacy Policy.</p>

        <Section>
          <h2>1. Information We Collect</h2>
          <p>We may collect and process the following types of information about you:</p>
          <ul>
            <li>Personal identification information (e.g., name, email address, phone number).</li>
            <li>Technical data such as IP address, browser type, and operating system.</li>
            <li>Usage data, including information about how you use our Site.</li>
          </ul>
        </Section>

        <Section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To provide, operate, and maintain our Site.</li>
            <li>To improve, personalize, and expand our Site.</li>
            <li>To communicate with you, including for customer service and support.</li>
            <li>To comply with legal obligations and enforce our terms and policies.</li>
          </ul>
        </Section>

        <Section>
          <h2>3. Sharing Your Information</h2>
          <p>We do not sell or rent your personal information to third parties. However, we may share your information with:</p>
          <ul>
            <li>Service providers who assist us in operating our Site.</li>
            <li>Legal authorities, if required by law or to protect our legal rights.</li>
          </ul>
        </Section>

        <Section>
          <h2>4. Data Security</h2>
          <p>We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>
        </Section>

        <Section>
          <h2>5. Your Rights</h2>
          <p>You have the following rights regarding your personal information:</p>
          <ul>
            <li>The right to access, update, or delete your personal information.</li>
            <li>The right to object to the processing of your personal information.</li>
            <li>The right to withdraw consent where processing is based on your consent.</li>
          </ul>
        </Section>

        <Section>
          <h2>6. Cookies</h2>
          <p>Our Site uses cookies to enhance your browsing experience. You can manage your cookie preferences through your browser settings.</p>
        </Section>

        <Section>
          <h2>7. Third-Party Links</h2>
          <p>Our Site may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. We encourage you to review their privacy policies before providing any personal information.</p>
        </Section>

        <Section>
          <h2>8. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this Privacy Policy periodically.</p>
        </Section>

        <Section>
          <h2>9. Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
          <p>Address: 12a Wentworth Road, London NW11 0RX, United Kingdom<br />
          Email: info@dreamsaicanbuy.com</p>
        </Section>
      </Content>
      <Footer />
    </div>
  );
};

const Content = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Section = styled.div`
  margin-bottom: 2rem;
  
  h2 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }
  
  ul {
    padding-left: 1.5rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
`;

export default PrivacyPolicy;
